// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__38ikm","resendInfoText":"OnGoingPaymentBox_resendInfoText__a36Cu"};